import { render } from "./NcrmCreateTaskDialog.vue?vue&type=template&id=6f1957a3"
import script from "./NcrmCreateTaskDialog.vue?vue&type=script&lang=js"
export * from "./NcrmCreateTaskDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__